var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33329C14.1082 3.33329 14.4957 3.33329 14.8136 3.41848C15.6764 3.64965 16.3502 4.32352 16.5814 5.18625C16.6666 5.50416 16.6666 5.89165 16.6666 6.66663V14.3333C16.6666 15.7334 16.6666 16.4335 16.3941 16.9683C16.1544 17.4387 15.772 17.8211 15.3016 18.0608C14.7668 18.3333 14.0667 18.3333 12.6666 18.3333H7.33325C5.93312 18.3333 5.23305 18.3333 4.69828 18.0608C4.22787 17.8211 3.84542 17.4387 3.60574 16.9683C3.33325 16.4335 3.33325 15.7334 3.33325 14.3333V6.66663C3.33325 5.89165 3.33325 5.50416 3.41844 5.18625C3.64961 4.32352 4.32347 3.64965 5.1862 3.41848C5.50412 3.33329 5.89161 3.33329 6.66659 3.33329M7.49992 12.5L9.16659 14.1666L12.9166 10.4166M7.99992 4.99996H11.9999C12.4666 4.99996 12.7 4.99996 12.8782 4.90913C13.035 4.82924 13.1625 4.70175 13.2424 4.54495C13.3333 4.36669 13.3333 4.13334 13.3333 3.66663V2.99996C13.3333 2.53325 13.3333 2.29989 13.2424 2.12163C13.1625 1.96483 13.035 1.83735 12.8782 1.75745C12.7 1.66663 12.4666 1.66663 11.9999 1.66663H7.99992C7.53321 1.66663 7.29985 1.66663 7.12159 1.75745C6.96479 1.83735 6.83731 1.96483 6.75741 2.12163C6.66659 2.29989 6.66659 2.53325 6.66659 2.99996V3.66663C6.66659 4.13334 6.66659 4.36669 6.75741 4.54495C6.83731 4.70175 6.96479 4.82924 7.12159 4.90913C7.29985 4.99996 7.53321 4.99996 7.99992 4.99996Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboard-list.e496b9690c9b74448cbfac4f1d28d234.svg";
export { ForwardRef as ReactComponent };